<template>
  <div class="i-detail-similar">
    <div class="i-detail-similar-title">
      ハッシュタグエンゲージメント
      <el-tooltip placement="top">
        <div slot="content">
          文字の大きさは、以下で決まります。<br>
          1. 90日以内の投稿で、かつ対象のハッシュタグが使用されている投稿のエンゲージメント（いいね数＋コメント数をフォロワー数で割った値）の平均を算出。<br>
          2. 「1」で算出した値に、対象のハッシュタグの使用回数を掛けた値で決まります。よってフォロワーがよく反応し、よく使用されているハッシュタグが大きく表示されます。<br>
          ※「#PR」は除外してあります。
        </div>
        <font-awesome-icon icon="question-circle" style="margin-left:3px; color:#666;" :class="printmode ? 'printmode' : ''" />
      </el-tooltip>
    </div>
    <word-cloud
        v-if="isValidData"
        :data="words"
        :font="fontFamily"
        :fontSizeMapper="fontSizeMapper"
        :onWordClick="wordClickHandler"
        :width="850"
        :height="400"
        :padding="15"
        ref="cloudComponent"
        @mouseover.native="handleMouseover"
        @mouseout.native="handleMouseout"
    />
    <div v-else class="report-nopost" style="height:auto">
      <img src="../../assets/report_image_3.png" style="opacity: 0.7; height:160px" alt />
      <div style="font-size: 20px;font-weight: 700; margin-bottom:10px">
        もう少しお待ちください
      </div>
      <div>
        データが不足しているため現在表示できません
      </div>
    </div>
    <div
        v-if="tooltip.visible"
        class="tooltip"
        :style="{
          top: tooltip.y + 'px',
          left: tooltip.x + 'px',
        }"
    >
      <div>{{ tooltip.num }}</div>
      <div>{{ tooltip.aegr }}</div>
    </div>
  </div>
</template>

<script>
import wordCloud from "vue-d3-cloud";

export default {
  name: "WordCloudComponent",
  props: {
    printmode: { type: Boolean, default: false },
    words: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    handleMouseover(event) {
      this.$nextTick(() => {
        if (event.target && event.target.__data__) {
          const offset = 10;
          this.tooltip.text = event.target.__data__.text;
          this.tooltip.num = '使用回数: ' + event.target.__data__.times;
          this.tooltip.aegr = '平均エンゲージメント率: ' + event.target.__data__.average_engagement_rate;
          this.tooltip.x = event.clientX + offset;
          this.tooltip.y = event.clientY + offset;
          this.tooltip.visible = true;
        }
      });
    },
    handleMouseout() {
      this.tooltip.visible = false;
    },
    wordClickHandler(word) {
      this.$emit('word-clicked', word.text);
    },
  },
  data() {
    return {
      fontSizeMapper: (word, words) => {
        // ここでの長さ5は、適宜調整してください。
        if (word.text.length > 15 || words.length > 30) {
          // 長い文字列のとき
          return Math.log2(word.value * 5) * 7;
        } else {
          // 短い文字列のとき
          const scaleFactor = 50;
          const fontBase = 5;
          const fontMin = 10;
          const size = Math.log2(word.value * scaleFactor) * fontBase;
          return Math.max(fontMin, size);
        }
      },
      tooltip: {
        text: null,
        x: 0,
        y: 0,
        arrowPos: 0,
        visible: false,
      },
      hoveredWord: null,
      fontFamily: 'Roboto, sans-serif',
    }
  },
  components: {
    wordCloud
  },
  computed: {
    isValidData() {
      return this.words && Array.isArray(this.words) && this.words.length > 0;
    }
  }
};
</script>

<style scoped>
.tooltip {
  opacity: 0.8;
  position: fixed;
  display: block !important;
  z-index: 10000;
  font-size: 0.9em;
  background-color: #333;
  color: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="right"] {
  margin-left: 5px;
}
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip[x-placement^="left"] {
  margin-right: 5px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
}
.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}
.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}
.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>